const HEREMAP_APP_ID = "5DlJnhtEiQKKlv6ds05L";
const HEREMAP_APP_CODE = "RX4lP3Pn3uayxBC2t1gP6A";

// Initial state

export const initialState = {
  H: {},
  platform: {}
};

// Actions

const INIT_HERE = "fv/maps/INIT_HERE";

// Action creators

export function initHere(H) {
  let platform = new H.service.Platform({
    app_id: HEREMAP_APP_ID,
    app_code: HEREMAP_APP_CODE,
    useCIT: true,
    useHTTPS: true
  });

  return {
    type: INIT_HERE,
    H: H,
    platform: platform
  };
}

// Reducer
export default function MapReducer(state = initialState, action = {}) {
  switch (action.type) {
    case INIT_HERE:
      return Object.assign({}, state, {
        H: action.H,
        platform: action.platform
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/map/MapState.js